export enum TaskNumeration {
    Company = "company",
    Project = "project",
}
